import { cloneDeep } from "lodash";
import { LESS_THAN_25LBS, MORE_THAN_25LBS, MORE_THAN_50LBS } from "config/tags";
import { IMPERIAL, METRIC } from "utils/measurementSystem";

const getWeightLossBoundariesAndSystem = () => {
  switch (window.ww.locale) {
    case "fr-CA":
    case "fr-FR":
    case "de-DE":
      return {
        lowerBound: 11,
        upperBound: 22,
        systemToUse: METRIC
      };

    case "en-GB":
      return {
        lowerBound: 1,
        upperBound: 3,
        systemToUse: IMPERIAL
      };

    case "en-US":
    case "en-CA":
    default:
      return {
        lowerBound: 25,
        upperBound: 50,
        systemToUse: IMPERIAL
      };
  }
};

// Shows different text on the "You’re in the right place!" screen
// based on goal weight.
export const getWeightLossResults = (profile, assessment) => {
  const { lowerBound, upperBound, systemToUse } =
    getWeightLossBoundariesAndSystem();
  const { weight, desiredWeight } = profile[systemToUse];
  const weightLoss = Math.round((weight - desiredWeight) * 10) / 10;
  let clonedQuestion = {};

  const lessThanLowerBound = assessment?.questions?.find(q =>
    q.tags.includes(LESS_THAN_25LBS)
  );

  if (weightLoss >= lowerBound && weightLoss < upperBound) {
    const middleBound = assessment?.questions?.find(q =>
      q.tags.includes(MORE_THAN_25LBS)
    );
    clonedQuestion = cloneDeep(lessThanLowerBound);
    clonedQuestion.headerText2 = middleBound.headerText2;
    clonedQuestion.images = middleBound.images;
    return clonedQuestion;
  } else if (weightLoss >= upperBound) {
    const moreThanUpperBound = assessment?.questions?.find(q =>
      q.tags.includes(MORE_THAN_50LBS)
    );
    clonedQuestion = cloneDeep(lessThanLowerBound);
    clonedQuestion.headerText2 = moreThanUpperBound.headerText2;
    clonedQuestion.images = moreThanUpperBound.images;
    return clonedQuestion;
  }
  return lessThanLowerBound;
};
